import React, { useEffect, useState } from 'react'
import TextEditor from '../components/TextEditor'
import Layout from './Layout'
import { RiNewspaperLine, RiEdit2Fill, RiCodeBoxLine, RiEditBoxFill, RiDeleteBin5Line, RiEraserFill, RiSave2Line, RiClipboardFill, RiClipboardLine, RiRefreshLine } from "react-icons/ri";
import EmbedCode from '../components/EmbedCode';
import UploadUrl from '../components/UploadUrl';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { getSaveUsers } from "../utilities/common"
import DeleteModal from '../components/DeleteModal';

export default function Event() {

    let navigate = useNavigate();

    const [showModal, setShowModal] = useState(false)
    const [eventTitle, setTitle] = useState("")
    const [eventAudio, setAudioUrl] = useState("")
    const [eventVideo, setVideoUrl] = useState("")
    const [eventImage, setImageUrl] = useState("")

    const [eventEditor, setEditor] = useState("")
    const [eidtEventItems, setEditEventItems] = useState()
    const [submitAction, setsubmitAction] = useState("add")


    const [listEventItems, setListEventItems] = useState([])
    const [showEmbedModal, setShowEmbedModal] = useState(false)
    const [embedData, setembedData] = useState()
    const [userData, setUserData] = useState()
    const [uploadUrl, setUploadUrl] = useState("")

    const [uploadUrlType, setUploadUrlType] = useState("")

    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [currentItem, setCurrentItem] = useState()

    const [descriptionError, setDescriptionError] = useState(false)

    const [unsptdVideoFormat, setUnsptdVideoFormat] = useState(false)
    const [unsptdAudioFormat, setUnsptdAudioFormat] = useState(false)
    const [unsptdImageFormat, setUnsptdImageFormat] = useState(false)

    let params = useParams();


    let urlParam = window?.location?.href?.split("/")
    localStorage.setItem('urlParam', JSON.stringify(urlParam))
    

    const resetValues = () => {
        setAudioUrl("")
        setVideoUrl("")
        setImageUrl("")
        setEditor("")
        setUnsptdImageFormat(false)
        setUnsptdVideoFormat(false)
        setUnsptdAudioFormat(false)
    }

    useEffect(() => {
        getEvents()
        let data = getSaveUsers()
        setUserData(data)


        if (data === null) {
            navigate("/")

        }
    }, [])

    const getEvents = () => {
        let data = {
            event_data_by_id:params.id
        }
        axios.post('https://li47hu6fx7.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Events',data)
            .then((res) => {
                setListEventItems(res.data.sort(function (a, b) { return new Date(b.event_time) - new Date(a.event_time) }))
                mppInstaFun()
                mppTwitterFun()
            })
            .catch(err => console.log(err))

        // axios.post('https://i5q7r5fa79.execute-api.ap-south-1.amazonaws.com/default/S3ImageUpload',data)
        // .then((res) => {
        //     console.log(res)
        //     setListEventItems(res.data.sort(function (a, b) { return new Date(b.event_time) - new Date(a.event_time) }))
        // })
        // .catch(err => console.error(err))
    }

    const ChangeUploadUrl = (url, type) => {
        setUploadUrlType(type)
        setShowModal(true)
        setUploadUrl(url)
    }

    const convertTime = (datetime) => {

        var hours = new Date(datetime).getHours();
        var minutes = new Date(datetime).getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = addZeroBefore(hours) + ':' + (minutes) + ' ' + ampm;
        return strTime;
    }

    function addZeroBefore(n) {
        return (n < 10 ? '0' : '') + n;
    }

    const addEventPost = () => {

        let audioFormat = ["mp3", "ogg"]
        let imageFormat = ["jpg", "png", "jpeg"]

        let imageArray = eventImage.split(".");
        let eventImageFormat = imageArray[imageArray.length - 1]

        let audioArray = eventAudio.split(".");
        let eventAudioFormat = audioArray[audioArray.length - 1]

        console.log(eventAudioFormat)

        var d = new Date()
        let data = {
            id: uuidv4(),
            event_id: params.id,
            event_title: eventTitle,
            event_description: eventEditor,
            event_imageurl: eventImage,
            event_videourl: eventVideo,
            event_audiourl: eventAudio,
            event_time: d,
            created_at: userData?.profileObj?.email,
            updated_by: "",
            status: "open"
        }
        setUploadUrlType("")



        if (eventEditor || eventImage || eventVideo || eventAudio) {
            setDescriptionError(false)



            if (eventVideo && eventVideo.length > 11) {
                setUnsptdVideoFormat(true)
                return
            } else if (eventImageFormat && imageFormat.includes(eventImageFormat) === false) {
                setUnsptdImageFormat(true)
                return
            } else if (eventAudioFormat && audioFormat.includes(eventAudioFormat) === false) {
                setUnsptdAudioFormat(true)
                return
            }

            if (submitAction === "add") {
                axios.post('https://li47hu6fx7.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Events', data)
                    .then((res) => {
                        toast.success('Event added', {
                            position: "bottom-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        resetValues()
                        getEvents()
                 
                    })
                    .catch(err => console.log(err))
            } else {
                data.id = eidtEventItems.Id
                data.event_time = eidtEventItems.event_time
                data.updated_by = userData?.profileObj?.email

                axios.put('https://li47hu6fx7.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Events', data)
                    .then((res) => {
                        setsubmitAction("add")
                        toast.success(`Event updated`, {
                            position: "bottom-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        resetValues()
                        getEvents()
                  
                    })
                    .catch(err => console.log(err))
            }
        } else {
            setDescriptionError(true)
        }

    }

    function createMarkup(items) {
        return { __html: items };
    }

    const eventDeleteClick = (items) => {

        let data = {
            id: currentItem.Id,
            event_id: currentItem.event_id,
            event_title: currentItem.event_title,
            event_description: currentItem.event_description,
            event_imageurl: currentItem.event_imageurl,
            event_videourl: currentItem.event_videourl,
            event_audiourl: currentItem.event_audiourl,
            event_time: currentItem.event_time,
            created_at: userData?.profileObj?.email,
            status: "delete"
        }

        axios.put(`https://li47hu6fx7.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-Events`, data)
            .then((res) => {
                setShowDeleteModal(false)
                getEvents()
                resetValues()
                
                toast.success('Event deleted', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
            .catch(err => console.log(err))
    }

    const evenetEditClick = (items) => {
        setEditEventItems(items)

        setsubmitAction("edit")

        setAudioUrl(items.event_audiourl)
        setVideoUrl(items.event_videourl)
        setImageUrl(items.event_imageurl)
        setEditor(items.event_description)


    }

    const previewClick = () => {
        navigate(`/preview/${params.id}/${params.name}`);

    }
    const embedCodeClick = () => {
        let data = {
            Id: params.id,
            event_name: params.name
        }
        setembedData(data)
        setShowEmbedModal(true)
    }

    const clearAll = () => {
        setTitle("")
        setVideoUrl("")
        setImageUrl("")
        setAudioUrl("")
        setEditor("")
    }
    const dateFormat = (datetime) => {
        const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        let date


        if (new Date().getFullYear() > new Date(datetime).getFullYear()) {
            date = month[new Date(datetime).getMonth()] + " " + new Date(datetime).getDate() + ", " + new Date(datetime).getFullYear()

        } else {
            date = month[new Date(datetime).getMonth()] + " " + new Date(datetime).getDate()

        }

        return date
    }

    const cancelEventPost = () => {
        clearAll()
        setsubmitAction("add")
    }
    const ClearField = (inputFiled) => {
        setVideoUrl("")
        setImageUrl("")
        setAudioUrl("")
        setEditor("")
    }

    const pasteFromClipboard = (inputField) => {
        if (inputField == "audio") {
            navigator.clipboard.readText()
                .then(text => setAudioUrl(text))
        } else if (inputField == "image") {
            navigator.clipboard.readText()
                .then(text => setImageUrl(text))
        } else if (inputField == "video") {
            navigator.clipboard.readText()
                .then(text => setVideoUrl(text))
        } else if (inputField == "editor") {
            navigator.clipboard.readText()
                .then(text => setEditor(text))
        }
    }

    const mppTwitterFun = () => {
        // window.twttr = (function (d, s, id) {
        //     var t, js, fjs = d.getElementsByTagName(s)[0];
        //     if (d.getElementById(id)) return; js = d.createElement(s); js.id = id;
        //     js.src = "https://platform.twitter.com/widgets.js"; fjs.parentNode.insertBefore(js, fjs);
        //     return window.twttr || (t = { _e: [], ready: function (f) { t._e.push(f) } });
        // }(document, "script", "twitter-wjs"));

        var s = document.createElement("script");
        s.src = "https://platform.twitter.com/widgets.js";
        s.async = true;
        document.getElementsByTagName('head')[0].appendChild(s);
        
    }

    const mppInstaFun = () =>{
        var s = document.createElement("script");
        s.src = "//platform.instagram.com/en_US/embeds.js";
        s.async = true;
        document.getElementsByTagName('head')[0].appendChild(s);
       
    }



    return (
        <div>
            <Layout>
                <div className="row">
                    <h4 className='p-0'>{submitAction === "edit" ? "Edit" : "Add"} News</h4>

                    <div className="col-md-6 p-0 pe-md-3 mb-3">
                        <div className="l-event-post px-3 py-4 l-event-post-container">
                            <form>

                                {/* <div class="mb-3">
                                    <label class="form-label fw-bold">Time</label>
                                    <input type="time" class="form-control" name="title" onChange={(e) => setTitle(e.target.value)} />
                                    <TimepickerComponent></TimepickerComponent>
                                </div> */}

                                <div className="d-flex justify-content-end">
                                    <p className=" l-cursor" onClick={() => clearAll()}><RiEraserFill className="mx-2" size="18"></RiEraserFill>Clear all</p>
                                </div>
                                <div class="mb-3">
                                    <div className='d-flex justify-content-between'>
                                        <div>
                                            <label for="exampleFormControlTextarea1" class="form-label fw-bold">Description</label>
                                        </div>
                                        <div>
                                            <RiEraserFill className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Clear text" onClick={() => setEditor("")}></RiEraserFill>
                                            <RiClipboardLine className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Paste clipboard" onClick={() => pasteFromClipboard("editor")}></RiClipboardLine>
                                        </div>
                                    </div>

                                    <TextEditor editorResetDate={eventEditor} editorData={(data) => setEditor(data)}></TextEditor>
                                    {descriptionError ? <span style={{ color: "red" }}>*description is required</span> : ""}
                                </div>
                                <div class="mb-3">

                                </div>
                                <div class="mb-3 row d-flex align-items-end p-0">
                                    <div className='col-md-8'>
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <label for="exampleFormControlTextarea1" class="form-label fw-bold">Image URL</label>
                                            </div>
                                            <div>
                                                <RiEraserFill className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Clear text" onClick={() => setImageUrl("")}></RiEraserFill>
                                                <RiClipboardLine className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Paste clipboard" onClick={() => pasteFromClipboard("image")}></RiClipboardLine>
                                            </div>
                                        </div>
                                        <input type="text" class="form-control" name="imageUrl" value={eventImage} onChange={(e) => setImageUrl(e.target.value)} placeholder='paste image url' />
                                    </div>
                                    <div className='col-md-4'>
                                        <button type="button" class="btn rounded-pill l-btn text-white" data-bs-toggle="modal" data-bs-target="#exampleModal"
                                            onClick={() => ChangeUploadUrl("https://app.mpp.in/polopolylite/akamai/akamaiupload1.php", "image")}>Upload Image</button>

                                    </div>
                                    {unsptdImageFormat ? <span style={{ color: "red" }}>*unsupported image format</span> : ""}
                                </div>
                                <div class="mb-3 row d-flex align-items-end p-0">
                                    <div className='col-md-8'>
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <label for="exampleFormControlTextarea1" class="form-label fw-bold">JW Video id</label>
                                            </div>
                                            <div>
                                                <RiEraserFill className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Clear text" onClick={() => setVideoUrl("")}></RiEraserFill>
                                                <RiClipboardLine className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Paste clipboard" onClick={() => pasteFromClipboard("video")}></RiClipboardLine>
                                            </div>
                                        </div>
                                        <input type="text" class="form-control" name="videoUrl" value={eventVideo} onChange={(e) => setVideoUrl(e.target.value)} placeholder='paste JW video id' />
                                    </div>
                                    <div className='col-md-4'>
                                        <button type="button" class="btn rounded-pill l-btn text-white mx-3" data-bs-toggle="modal" data-bs-target="#exampleModal"
                                            onClick={() => ChangeUploadUrl("https://brightcove.mathrubhumi.com/brightcove/pololite/jwplayer/code/index_new.php", "video")}>Upload video</button>
                                    </div>
                                    {unsptdVideoFormat ? <span style={{ color: "red" }}>*unsupported video format</span> : ""}
                                </div>
                                <div class="mb-3 row d-flex align-items-end p-0">
                                    <div className='col-md-8'>
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <label for="exampleFormControlTextarea1" class="form-label fw-bold">Audio URL</label>
                                            </div>
                                            <div>
                                                <RiEraserFill className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Clear text" onClick={() => setAudioUrl("")}></RiEraserFill>
                                                <RiClipboardLine className='mx-2 l-cursor' data-bs-toggle="tooltip" data-bs-placement="top" title="Paste clipboard" onClick={() => pasteFromClipboard("audio")}></RiClipboardLine>
                                            </div>
                                        </div>
                                        <input type="text" class="form-control" name="audioUrl" value={eventAudio} onChange={(e) => setAudioUrl(e.target.value)} placeholder='paste audio url' />
                                    </div>
                                    <div className='col-md-4'>
                                        <button type="button" class="btn rounded-pill l-btn text-white" data-bs-toggle="modal" data-bs-target="#exampleModal"
                                            onClick={() => ChangeUploadUrl("https://app.mpp.in/audiostore/upload.php", "audio")}>Upload Audio</button>
                                    </div>
                                    {unsptdAudioFormat ? <span style={{ color: "red" }}>*unsupported audio format</span> : ""}
                                </div>

                                <div className='d-flex'>
                                    <button type="button" class="btn btn-primary " onClick={(e) => addEventPost(e)}>{submitAction === "edit" ? "Update" : "Submit"}</button>
                                    {submitAction === "edit" ? <button type="button" class="btn btn-danger" onClick={(e) => cancelEventPost(e)}>Cancel</button> : ""}
                                </div>


                            </form>
                        </div>
                    </div>
                    {/* <div className="col-md-1 d-flex justify-content-center">

                        <div className="l-horizontal-line">
                        </div>
                    </div> */}
                    <div className="col-md-6 l-event-post p-0 mb-3">
                        <div className="card border-0 l-event-post">
                            <div className="l-event-post-header p-3">
                                <h3 className="m-0">{params.name}</h3>
                            </div>
                            <div className="l-event-actions my-2 d-flex justify-content-between align-items-center px-3">
                                <div className="">
                                    {/* <h5 className="m-0">NEWS</h5> */}
                                    <p class="m-0 l-cursor" onClick={() => getEvents()}><RiRefreshLine className="mx-1" size={20} ></RiRefreshLine>Refresh</p>

                                </div>
                                <div className="d-flex l-event-actinos-btn">
                                    <Link to={`/preview/${params.id}/${params.name}`} target="_blank">
                                        <button type="button" class="btn mx-2 d-flex align-items-center"><RiNewspaperLine className="mx-1" size={20}></RiNewspaperLine>Preview</button>
                                    </Link>
                                    {/* <button type="button" class="btn mx-2 d-flex align-items-center"><RiEdit2Fill className="mx-1" size={20}></RiEdit2Fill>Edit</button> */}
                                    <button type="button" class="btn mx-2 d-flex align-items-center" onClick={() => embedCodeClick()}><RiCodeBoxLine className="mx-1" size={20}></RiCodeBoxLine>Embed Code</button>
                                </div>


                            </div>
                            {/* <div className="" style={{ backgroundColor: "#f6f6f6", width: "100%", height: "1px" }}></div> */}

                            <div className="l-event-news-list mt-3 p-3">
                                {
                                    listEventItems?.filter(e => e.status === "open").map((items) => (
                                        <div className="l-event-news px-2" key={items.Id}>
                                            <div className="l-event-news-head d-flex justify-content-between">
                                                <div className="l-event-news-time" style={{ backgroundColor: "grey", borderRadius: "5px", width: "max-content" }}>
                                                    <p className="m-0 text-white p-1 px-2" style={{ fontSize: "10px" }}>{convertTime(items.event_time)} , {dateFormat(items.event_time)}</p>
                                                </div>
                                                <div className="l-event-news-more-action d-flex me-3">
                                                    <p className="m-0 mx-2 l-cursor" onClick={() => evenetEditClick(items)} data-toggle="tooltip" data-placement="bottom" title="Edit"><RiEdit2Fill></RiEdit2Fill></p>
                                                    <p className="m-0 l-cursor mx-2" onClick={() => { setShowDeleteModal(true); setCurrentItem(items) }} data-toggle="tooltip" data-placement="bottom" title="Delete" ><RiDeleteBin5Line></RiDeleteBin5Line></p>

                                                </div>
                                            </div>
                                            <div className="l-event-news-content m-0 pt-3 malayalam">
                                                {items.event_imageurl ? <img src={items.event_imageurl} className="img-fluid mb-3" style={{ width: "100%" }} /> : ""}
                                                {items.event_videourl ? <p style={{ height: "34vh" }}>
                                                    <iframe src={`https://cdn.jwplayer.com/players/${items.event_videourl}-dbzR9ypW.html`} allowfullscreen webkitallowfullscreen mozallowfullscreen style={{ top: "0px", right: "0px", bottom: "0px", left: "0px", width: "100%", height: "100%" }}></iframe> </p>
                                                    : ""}
                                                {items?.event_audiourl ? <audio controls>
                                                    <source src={items.event_audiourl} type="audio/ogg" />
                                                    <source src={items.event_audiourl} type="audio/mpeg" />
                                                    Your browser does not support the audio element.
                                                </audio> : ""}

                                                <p dangerouslySetInnerHTML={createMarkup(items.event_description)}></p>
                                            </div>
                                            <p className="l-date m-0 pt-3 malayalam d-flex justify-content-end">created by: {items.created_at}</p>
                                            {items?.updated_by ?
                                                <p className="l-date m-0 malayalam d-flex justify-content-end">updated by: {items?.updated_by}</p> : ""}

                                            <hr></hr>
                                        </div>
                                    ))}
                            </div>

                        </div>
                    </div>
                </div >
            </Layout >


            <UploadUrl showModal={showModal} uploadUrl={uploadUrl} closeModal={() => setShowModal(false)}></UploadUrl>

            <ToastContainer />

            <EmbedCode data={embedData} showEmbedModal={showEmbedModal} closeModal={() => setShowEmbedModal(false)}></EmbedCode>

            <DeleteModal onDeleteFunction={() => eventDeleteClick()} onCancelFunction={() => setShowDeleteModal(false)} showDeleteModal={showDeleteModal}></DeleteModal>

        </div >



    )
}
